import { render } from "./SenaraiNotisPentadbiran.vue?vue&type=template&id=65dc3bb4"
import script from "./SenaraiNotisPentadbiran.vue?vue&type=script&lang=js"
export * from "./SenaraiNotisPentadbiran.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__